import React from "react";
import { connect } from "react-redux";
import { Modal as BModal } from "react-bootstrap";
import moment from "moment";
import Menu from "../menu";
import {
  Table,
  Pagination,
  Button,
  Select,
  Icon,
  Modal,
  Input,
  DatePicker
} from "../../components";
import { axios, Constants, Globals, ENV } from "../../utils";
import CreateEditClient from "./create_edit_client";
import ViewClient from "./view_client";
import AddIcon from '../../assets/icons/add.png';
import uploadExcelDesktop from '../../assets/icons/upload-excel-desktop.png';
import ExcelFile from '../../assets/icons/excel-file.png';
import UploadFile from '../../assets/icons/upload.png';
import PrinterIcon from '../../assets/icons/printer.png';
import DeudaIcon from '../../assets/icons/ico_Deuda.png';

class Clients extends React.Component {
  constructor(props) {
    super(props);

    const countryEquivalent = Globals.getUserCountryEquivalent();

    this.state = {
      page: 1,
      last_page: 1,
      searchTimeout: null,
      data: [],
      zones: [],
      client_categories: [],
      sellers: [],
      enterprises: [],
      retentions: [],
      user: null,
      view: false,
      selectedClient: null,
      list_status: [
        { value: '', label: "Todos" },
        { value: 1, label: "Activos" },
        { value: 0, label: "Inactivos" }
      ],
      list_person_type: [
        { value: "", label: "Todos" },
        { value: 1, label: "Naturales" },
        { value: 2, label: "Juridicas" }
      ],
      form: {
        status: null,
        person_type: "",
        zone: "",
        client_category_id: "",
        search: null,
        user_id: this.props.user.id,
        role: props.user.role,
        admin_id: this.props.user.level_id === Constants.ROLE_ADMIN ? this.props.user.id : this.props.user.admin_id,
        web: true,
        since: '',
        until: '',
      },
      dates: {
        minDate: "",
        maxDate: ""
      },
      modalUploadExcel: false,
      countryEquivalent,
      HEADER_TABLE: [
        "Nombre/Razón social",
        "Email",
        countryEquivalent.bothDni,
        "Teléfono",
        "Zona",
        "Categoría",
        "Estatus",
        "Creado por",
        "Fecha creación",
        "Acciones"
      ],
    };
  }

  componentDidMount() {
    this.load();
  }

  componentWillUnmount() {
    if (this.state.searchTimeout) clearTimeout(this.state.searchTimeout);
  }

  load = () => {
    const { page, form } = this.state;
    Globals.setLoading();
    axios
      .post("web/admin/clients?page=" + page, {
        ...form,
        since: form.since ? moment(form.since, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
        until: form.until ? moment(form.until, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
      })
      .then(res => {
        if (res.data.clients) {
          this.setState({
            last_page: res.data.clients.last_page,
            data: res.data.clients.data
          });
        }
      })
      .catch(err => {
        Globals.showError();
      })
      .then(() => {
        Globals.quitLoading()
        //this.getEnterprises();
        //this.getRetentions();
        this.getZones();
        this.getClientCategories();
        this.getSellers();
      });
  };

  close = () => {
    this.setState(
      {
        create: false,
        view: false,
        edit: null,
        user: null,
        modalUploadExcel: false,
      },
      () => this.load()
    );
  };

  delete = item => {
    const removeMsg = `¿Desea eliminar a: ${item.name}?`;
    const hasToPayOrders = (item?.to_pay_orders?.length ?? 0) > 0;
    const toPayMsg = hasToPayOrders ? '\n(este usuario tiene cuentas por cobrar)' : '';

    Globals.confirm(removeMsg + toPayMsg, () => {
      Globals.setLoading("Guardando...");
      axios
        .post(`web/admin/clients/delete/${item.id}`)
        .then(res => {
          Globals.showSuccess('Cliente eliminado');
          this.load();
        })
        .catch(err => Globals.showError(err.response.data.msg))
        .then(() => Globals.quitLoading());
    });
  };

  suspend = item => {
    let message = '';
    const isActive = item.status === Constants.STATUS_ACTIVE;
    message = !!isActive
      ? `¿Deseas desactivar a ${item.name}? No se podrán registrar pedidos mientras permanezca inactivo.`
      : `¿Deseas activar a ${item.name}? El cliente podrá registrar pedidos nuevamente.`;

    Globals.confirm(message, () => {
      Globals.setLoading("Guardando...");
      axios
        .post("web/admin/clients/setstatus", { client_id: item.id })
        .then(res => {
          Globals.showSuccess(res.data.msg);
          this.load();
        })
        .catch(err => Globals.showError(err.response.data.msg))
        .then(() => Globals.quitLoading());
    });
  };

  print = () => {
    axios
      .post('web/admin/clients/download', {
        ...this.state.form,
        since: this.state.form.since ? moment(this.state.form.since, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
        until: this.state.form.until ? moment(this.state.form.until, 'DD-MM-YYYY').format('YYYY-MM-DD') : '',
        user_id: this.props.user.id,
        web: true,
      })
      .then(res => {
        const url = `${ENV.BasePublic}${res.data.url_storage}`;
        const win = window.open(url, "_blank");
        win.focus();
      })
      .catch(err => {
        console.log('Clientes -> download -> catch: ', err);
      });
  }

  verify = item => {
    Globals.confirm("¿Desea verificar a: " + item.first_name + "?", () => {
      Globals.setLoading("Guardando...");
      axios
        .post("admin/clients/verify", { id: item.id })
        .then(res => {
          Globals.showSuccess(res.data.msg);
          this.load();
        })
        .catch(err => Globals.showError(err.response.data.msg))
        .then(() => Globals.quitLoading());
    });
  };

  change = ({ target }) => {
    const { name, value, type } = target;
    const isText = !['select-one', 'select-multiple', 'checkbox', 'radio'].includes(type);

    this.setState(
      state => ({ form: { ...state.form, [name]: value } }),
      () => this.autoFilter(isText)
    );
  };

  autoFilter = (isText = false) => {
    if (this.state.searchTimeout) clearTimeout(this.state.searchTimeout);
    if (isText) {
      const t = setTimeout(() => {
        this.setState({ page: 1 }, () => this.load());
      }, 400);
      this.setState({ searchTimeout: t });
    } else {
      this.setState({ page: 1 }, () => this.load());
    }
  };

  getZones = () => {
    axios
      .post("web/admin/zones", { user_id: this.props.user.id })
      .then(({ data }) => {
        data.zones.unshift({ id: "x", name: "Sin Zona" });
        data.zones.unshift({ id: "", name: "Todas" });

        this.setState({
          zones: data.zones
        });
      })
      .catch(() => Globals.showError())
      .then(() => Globals.quitLoading());
  };

  getClientCategories = () => {
    axios
      .post("admin/clients/categories", { user_id: this.props.user.id, is_select: true })
      .then(({ data }) => {
        data.categories.unshift({ id: "x", name: "Sin Categoría" });
        data.categories.unshift({ id: "", name: "Todas" });

        this.setState({
          client_categories: data.categories
        });
      })
      .catch(() => Globals.showError())
      .then(() => Globals.quitLoading());
  };

  getSellers = () => {
    axios
      .post("web/admin/sellers", { user_id: this.props.user.id, for_select: true })
      .then(({ data }) => {
        this.setState({ sellers: data.sellers.data });
      })
      .catch(() => Globals.showError())
      .then(() => Globals.quitLoading());
  };

  getEnterprises = () => {
    axios
      .get("admin/warehouses/enterprises")
      .then(res => {
        if (res.data.result) {
          this.setState({
            enterprises: res.data.users
          });
        }
      })
      .catch(() => Globals.showError());
  };

  getRetentions = () => {
    axios
      .get("admin/clients/retentions")
      .then(res => {
        this.setState({
          retentions: res.data
        });
      })
      .catch(() => Globals.showError());
  };

  downloadFormat = () => {
    Globals.setLoading();
    const { user } = this.props;

    let param = {
      user_id: user.id
    };

    axios
      .post("web/admin/clients/download-format", this.state.form)
      .then(res => {
        if (res.data.url_storage) {
          const url = `${ENV.BasePublic}${res.data.url_storage}`;

          const element = document.createElement('a');
          element.href = url;
          element.download = 'Carga_Masiva_Clientes';
          element.click();

          Globals.quitLoading()
        }
        else {
          Globals.showError('Ha ocurrido un error');
        }
      })
      .catch(err => {
        Globals.showError();
      });
  };

  chooseFile = async (e) => {
    if (!e.target.files.length) return;
    const currentFile = URL.createObjectURL(e.target.files[0]);

    const data = {
      ...this.state.form,
      file: e.target.files[0],
      currentFile: currentFile,
    };

    e.target.value = "";

    Globals.confirm('¿Realmente desea subir el archivo?', async () => {
      await this.setState({ form: { ...data } });

      Globals.setLoading();
      axios
        .upload("web/admin/clients/import-excel", data)
        .then(async res => {
          if (res.data.result) {
            Globals.showSuccess(res.data.msg);

            await this.setState({
              form: {
                ...this.state.form,
                file: {},
                currentFile: "",
              }
            });
            this.load();
          }
          else {
            if (res?.data?.error) {
              const errorMsg = res.data.fila
                ? `Error en la fila ${res.data.fila}: ${res.data.error}`
                : res.data.error;
              Globals.showError(errorMsg);
            } else {
              Globals.showError('No se pudo procesar el archivo correctamente.');
            }
          }
        })
        .catch(err => {
          console.error(err);
          // Intentamos obtener el error desde la respuesta HTTP en caso de un código 4xx o 5xx
          const data = err.response?.data;
          let errorMsg = 'Ha ocurrido un error inesperado al subir el archivo.';

          if (data?.error) {
            errorMsg = data.fila ? `Error en la fila ${data.fila}: ${data.error}` : data.error;
          } else if (data?.message) {
            errorMsg = data.message;
          }

          Globals.showError(errorMsg);
        })
        .then(() => Globals.quitLoading());
    });
  }

  render() {
    const {
      create,
      data,
      edit,
      modalUploadExcel,
      enterprises,
      last_page,
      list_person_type,
      retentions,
      page,
      person_type,
      list_status,
      user: client,
      view,
      zones,
      client_categories,
      selectedClient,
      sellers,
      form,
    } = this.state;

    const { history, user } = this.props;

    const filtered_zones = zones.filter(Item => {
      return Item.id && Item.id > 0;
    });

    const filtered_clientCategories = client_categories.filter(Item => {
      return Item.id && Item.id > 0;
    });

    const currentDate = new Date();
    const threeMonthsAgo = new Date(currentDate.getFullYear(), currentDate.getMonth() - 2);
    const threeMonthsName = new Intl.DateTimeFormat("es-ES", { month: "long" }).format(threeMonthsAgo);
    const monthName = new Intl.DateTimeFormat("es-ES", { month: "long" }).format(currentDate);

    return (
      <Menu history={history}>
        {view && (
          <Modal title="Ver Cliente" onClose={this.close} visible>
            <ViewClient user={client} />
          </Modal>
        )}

        {create && (
          <Modal
            title={edit ? "Editar Cliente" : "Nuevo Cliente"}
            size="lg"
            onClose={this.close}
            visible
          >
            <CreateEditClient
              user={user}
              edit={edit}
              //enterprises={enterprises}
              zones={filtered_zones}
              client_categories={filtered_clientCategories}
              //retentions={retentions}
              onClose={this.close}
              sellers={sellers}
            />
          </Modal>
        )}

        <Modal
          size="lg"
          className="modal-cxc-client"
          title="Cuentas por cobrar"
          onClose={() => this.setState({ selectedClient: null })}
          visible={selectedClient}
        >
          <div style={{ marginBottom: '14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
            <span style={{ fontSize: '15px' }}>
              Cliente: <b style={{ color: '#10357f' }}>{selectedClient?.name}</b>
            </span>
            {selectedClient?.document && (
              <span style={{ fontSize: '13px', color: '#64748b' }}>
                RIF/Doc: <b style={{ color: '#334155' }}>{selectedClient.document}</b>
              </span>
            )}
          </div>

          <div className="table-responsive" style={{ maxHeight: '65vh', overflowY: 'auto' }}>
            <table className="cxc-client-table">
              <thead>
                <tr>
                  <th style={{ width: '120px', textAlign: 'center' }}>Fecha</th>
                  <th style={{ minWidth: '160px', textAlign: 'left' }}>Factura / Doc.</th>
                  <th style={{ width: '120px', textAlign: 'center' }}>Vencimiento</th>
                  <th style={{ width: '125px', textAlign: 'right' }}>Deuda</th>
                  <th style={{ width: '125px', textAlign: 'right' }}>Abono</th>
                  <th style={{ width: '125px', textAlign: 'right' }}>Por Cobrar</th>
                </tr>
              </thead>
              <tbody>
                {(!selectedClient?.to_pay_orders || selectedClient.to_pay_orders.length === 0) ? (
                  <tr>
                    <td colSpan={6} style={{ textAlign: 'center', padding: '24px', color: '#64748b' }}>
                      No hay cuentas por cobrar pendientes para este cliente.
                    </td>
                  </tr>
                ) : (
                  selectedClient.to_pay_orders.map((item, index) => {
                    const formatAmount = (val) => {
                      const num = Number(val || 0);
                      if (num < 0) {
                        return `-$${Globals.formatMiles(Math.abs(num))}`;
                      }
                      return `$${Globals.formatMiles(num)}`;
                    };

                    return (
                      <tr key={index}>
                        <td style={{ textAlign: 'center' }}>
                          {item?.created_es || '—'}
                        </td>
                        <td style={{ fontWeight: 600, color: '#1e293b' }}>
                          {item?.number_format || item?.correlative_number || item?.id || '—'}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {item?.payment_date ? moment(item.payment_date).format('DD/MM/YYYY') : '—'}
                        </td>
                        <td style={{ textAlign: 'right', fontWeight: 600 }}>
                          {formatAmount(item?.total)}
                        </td>
                        <td style={{ textAlign: 'right' }}>
                          {formatAmount(item?.partial_payment_total)}
                        </td>
                        <td style={{ textAlign: 'right', fontWeight: 700, color: Number(item?.to_pay) < 0 ? '#16a34a' : '#dc2626' }}>
                          {formatAmount(item?.to_pay)}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
              {selectedClient?.to_pay_orders && selectedClient.to_pay_orders.length > 0 && (
                <tfoot>
                  <tr>
                    <td colSpan={3} style={{ textAlign: 'center' }}>
                      TOTAL
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      {Number(selectedClient?.totalDeuda) < 0
                        ? `-$${Globals.formatMiles(Math.abs(selectedClient?.totalDeuda))}`
                        : `$${Globals.formatMiles(selectedClient?.totalDeuda || 0)}`}
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      {Number(selectedClient?.totalAbono) < 0
                        ? `-$${Globals.formatMiles(Math.abs(selectedClient?.totalAbono))}`
                        : `$${Globals.formatMiles(selectedClient?.totalAbono || 0)}`}
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      {Number(selectedClient?.totalToPay) < 0
                        ? `-$${Globals.formatMiles(Math.abs(selectedClient?.totalToPay))}`
                        : `$${Globals.formatMiles(selectedClient?.totalToPay || 0)}`}
                    </td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </Modal>

        <BModal show={modalUploadExcel} onHide={() => this.close()} size="lg" id="modal-upload-excel">
          <BModal.Body>
            <UploadExcelFile
              download={() => this.downloadFormat()}
              onUpload={this.chooseFile}
              onClose={() => this.close()}
            />
          </BModal.Body>
        </BModal>

        <div id="home">
          <div className="row">
            <div className="col-sm-12 col-md-4">
              <Input
                color=" "
                name="search"
                label="Búsqueda"
                className="filter"
                onChange={this.change}
                value={form.search}
                placeholder={`Buscar por Nombre, Email, ${this.state.countryEquivalent.bothDni || ''}`}
              />
            </div>
            <div className="col-sm-12 col-md-2">
              <Select
                color="white"
                name="status"
                label="Estatus"
                className="filter"
                defaultname="Seleccione"
                onChange={this.change}
                value={form.status}
                options={list_status.map(({ value, label }) => ({
                  value: value,
                  label: label
                }))}
              />
            </div>
            {/* <div className="col-sm-12 col-md">
              <Select
                color="white"
                name="person_type"
                label="Personalidad"
                className="filter"
                defaultname="Seleccione"
                onChange={this.change}
                value={person_type}
                options={list_person_type.map(i => {
                  return {
                    value: i.value,
                    label: i.label
                  };
                })}
              />
            </div> */}
            <div className="col-sm-12 col-md-2">
              <Select
                color="white"
                name="zone"
                label="Zonas"
                className="filter"
                defaultname="Seleccione"
                onChange={this.change}
                value={form.zone}
                options={this.state.zones.map(x => ({ value: x.id, label: x.name }))}
              />
            </div>
            <div className="col-sm-12 col-md-2">
              {this.state.client_categories.length > 2 && (
                <Select
                  color="white"
                  name="client_category_id"
                  label="Categorías"
                  className="filter"
                  defaultname="Seleccione"
                  onChange={this.change}
                  value={form.client_category_id}
                  options={this.state.client_categories.map(x => ({ value: x.id, label: x.name }))}
                />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-2">
              <DatePicker
                color="white"
                label="Desde"
                className="filter"
                minDate={this.state.dates.minDate}
                value={this.state.form.since}
                onChange={value => {
                  this.setState(
                    state => ({ form: { ...state.form, since: value } }),
                    () => this.autoFilter(false)
                  );
                }}
              />
            </div>
            <div className="col-sm-12 col-md-2">
              <DatePicker
                color="white"
                label="Hasta"
                className="filter"
                maxDate={this.state.dates.maxDate}
                value={this.state.form.until}
                onChange={value => {
                  this.setState(
                    state => ({ form: { ...state.form, until: value } }),
                    () => this.autoFilter(false)
                  );
                }}
              />
            </div>
            <div className="col-sm-12 col-md">
              <Button
                className="btn-align-bottom btn-filter ml-2"
                color=" "
                onClick={async () => {
                  await this.setState({
                    page: 1,
                    form: {
                      ...this.state.form,
                      search: '',
                      status: '',
                      zone: '',
                      client_category_id: '',
                      since: '',
                      until: ''
                    }
                  });
                  this.load();
                }}
              >
                <span>Limpiar</span>
              </Button>
            </div>
          </div>
          <div className="col-12">
            <button
              className="btn btn-filter"
              style={{ marginTop: 10, marginBottom: 20 }}
              onClick={() => this.setState({ modalUploadExcel: true })}
            >
              <img src={AddIcon} style={{ width: 24, marginRight: '0.5rem' }} alt="Subir Excel" />
              <span>Subir masivamente clientes en excel</span>
            </button>
          </div>

          <Table
            data={data.length}
            title="Clientes"
            header={this.state.HEADER_TABLE}
            right={
              <div>
                <Button
                  title="Imprimir"
                  small="true"
                  onClick={() => this.print()}
                >
                  <img src={PrinterIcon} style={{ width: 24 }} alt="Imprimir" />
                </Button>
                <Button
                  title="Agregar Clientes"
                  small="true"
                  onClick={() => {
                    this.setState({
                      create: true
                    });
                  }}
                >
                  <img src={AddIcon} alt="Agregar Clientes" />
                </Button>
              </div>
            }
          >
            {data.map((i, index) => {
              const totalDeuda = i?.to_pay_orders?.reduce((a, b) => a + Number(b?.total), 0);
              const totalAbono = i?.to_pay_orders?.reduce((a, b) => a + b?.partial_payment_total, 0);
              const totalToPay = i?.to_pay_orders?.reduce((a, b) => a + b?.to_pay, 0);

              return (
                <tr key={index}>
                  <td>
                    {!!i?.to_pay_orders?.length ? (
                      <span
                        className="clickable-red"
                        onClick={() => this.setState({ selectedClient: { ...i, totalToPay, totalDeuda, totalAbono } })}
                      >
                        {i.name} <img src={DeudaIcon} />
                      </span>
                    ) : <span> {i.name} </span>}
                  </td>
                  <td>{i.email}</td>
                  <td align={""}>
                    {i.document ?? ''}
                  </td>
                  <td>{i.phone}</td>
                  <td>{Globals.getZoneLabel(i.zone) ?? 'Sin zona'}</td>
                  <td>{i.category?.name ?? 'Sin categoría'}</td>
                  <td style={{ color: Globals.getStatus(i.status).color }}>
                    {/* {Globals.getStatus(i.status).text} */}
                    {i.status === Constants.CLIENT.STATUS.INACTIVE ? 'Inactivo' : 'Activo'}
                  </td>
                  <td>{i?.creator?.name ?? '-'}</td>
                  <td>{moment(i.created_at).format('DD/MM/YYYY')}</td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>

                      <Button
                        title="Ver"
                        small="true"
                        color="primary"
                        onClick={() => {
                          this.setState({
                            user: i,
                            view: true
                          });
                        }}
                      >
                        <Icon name="eye" />
                      </Button>

                      <Button
                        title="Editar"
                        small="true"
                        color=" "
                        style={{ backgroundColor: '#0f54e0' }}
                        onClick={() =>
                          this.setState({
                            create: true,
                            edit: {
                              element: i,
                              index: index
                            }
                          })
                        }
                      >
                        <Icon name="edit" />
                      </Button>

                      {/* Mantengo tu bloque de estilos, pero recuerda la recomendación 
        de intentar ponerlo fuera del .map() si es posible para optimizar rendimiento */}
                      <style>
                        {`
                          .custom-toggle-switch {
                            position: relative;
                            display: inline-block;
                            width: 44px;
                            height: 24px;
                            margin: 0; /* Aseguramos que no tenga márgenes extra que deformen la fila */
                          }
                          .custom-toggle-switch input {
                            opacity: 0;
                            width: 0;
                            height: 0;
                          }
                          .toggle-slider {
                            position: absolute;
                            cursor: pointer;
                            top: 0; left: 0; right: 0; bottom: 0;
                            background-color: #ccc;
                            transition: 0.3s ease-in-out;
                            border-radius: 24px;
                          }
                          .toggle-slider:before {
                            position: absolute;
                            content: "";
                            height: 18px;
                            width: 18px;
                            left: 3px;
                            bottom: 3px;
                            background-color: white;
                            transition: 0.3s ease-in-out;
                            border-radius: 50%;
                            box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                          }
                          .custom-toggle-switch input:checked + .toggle-slider {
                            background-color: #4cd964;
                          }
                          .custom-toggle-switch input:checked + .toggle-slider:before {
                            transform: translateX(20px);
                          }
                          .custom-toggle-switch input:focus-visible + .toggle-slider {
                            outline: 2px solid #005fcc;
                            outline-offset: 2px;
                          }
                        `}
                      </style>

                      <label
                        className="custom-toggle-switch"
                        title={i.status === Constants.CLIENT.STATUS.ACTIVE ? "Desactivar cliente" : "Activar cliente"}
                      >
                        <input
                          type="checkbox"
                          checked={i.status === Constants.CLIENT.STATUS.ACTIVE}
                          onChange={() => this.suspend(i, index)}
                          aria-label={`Cambiar estado de ${i.name || 'este cliente'}`}
                          aria-checked={i.status === Constants.CLIENT.STATUS.ACTIVE}
                        />
                        <span className="toggle-slider"></span>
                      </label>

                      <Button
                        color="red"
                        title="Eliminar"
                        small="true"
                        onClick={() => this.delete(i, index)}
                      >
                        <Icon name="trash" />
                      </Button>

                    </div>
                  </td>
                </tr>
              );
            })}
          </Table>

          <Pagination
            pages={last_page}
            active={page}
            onChange={page => {
              this.setState(
                {
                  page: page
                },
                () => {
                  this.load();
                }
              );
            }}
          />
        </div>
      </Menu>
    );
  }
}

const UploadExcelFile = ({ download, onUpload, onClose }) => (
  <>
    <div className="banner">
      <img src={uploadExcelDesktop} alt="Subir excel" />
    </div>

    <div className="content">
      <p>
        <b>Paso 1-</b> Descarga el archivo de excel
        <div>
          <button className="btn btn-primary p-2" onClick={download}>
            <img src={ExcelFile} alt="Descargar excel" />
            <span>Descargar Archivo Excel</span>
          </button>
        </div>
      </p>
      <p><b>Paso 2-</b> Carga la información de tus clientes, en el orden indicado en el excel:</p>
      <ul style={{ fontSize: "13px", textAlign: "left", background: "#f8f9fa", padding: "10px 25px", borderRadius: "5px", marginBottom: "15px" }}>
        <li><b>nombre y apellido:</b> Obligatorio.</li>
        <li><b>RIF:</b> Obligatorio. Documento de identidad.</li>
        <li><b>email:</b> Correo electrónico del cliente.</li>
        <li><b>teléfono:</b> Número de teléfono de contacto.</li>
        <li><b>zona / código de zona:</b> Ubicación y código de zona.</li>
        <li><b>dirección:</b> Dirección detallada.</li>
        <li><b>codigo vendedor:</b> Código interno del vendedor del cliente (opcional).</li>
        <li><b>latitud / longitud:</b> <span style={{ color: "#d32f2f" }}>Debe ser numérico usando <b>PUNTO (.)</b> como separador decimal, NO coma (Ejemplo: 9.4284, -64.479).</span></li>
      </ul>
      <p><b>Paso 3-</b> Sube tu archivo excel con la información de tus clientes</p>
      {/* <p><b>Los clientes con códigos repetidos no podrán ser cargados.</b></p> */}
    </div>

    <div className="actions">
      <button className="btn p-2" onClick={onClose}>
        <span>Cerrar</span>
      </button>

      <label className="btn p-2" htmlFor="excel-file">
        <img src={UploadFile} alt="Descargar excel" />
        <span>Subir Formato de Clientes</span>
      </label>
    </div>

    <input
      id="excel-file"
      type="file"
      accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      onChange={onUpload}
      style={{ display: 'none' }}
    />
  </>
);

export default connect(state => {
  return {
    user: state.user
  };
})(Clients);

